import {
  APIWorkspaceFolder,
  ArdoqId,
  AssetPayload,
  Persisted,
} from '@ardoq/api-types';
import { createEntity, fetchEntities, renameEntity } from './api';

type MovedAssets = {
  targetFolderId: ArdoqId | null;
  content: AssetPayload[];
};

type PersistedMovedAssets = Persisted<MovedAssets>;

export const workspaceFolderApi = {
  moveAssets: createEntity<PersistedMovedAssets>('workspacefolder/asset/move'),
  create: createEntity<APIWorkspaceFolder>('workspacefolder'),
  rename: renameEntity<APIWorkspaceFolder>('workspacefolder'),
  fetchAll: fetchEntities<APIWorkspaceFolder>('workspacefolder'),
};
